import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tora-lernen',
  templateUrl: './tora-lernen.component.html',
  styleUrls: ['./../app.component.css']
})
export class ToraLernenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
